export enum EnumIdsTcTipoSolicitudCam {
    ID_PARCELA = 1,
    ID_CONFECCION = 2,
    ID_INVERNADERO = 3,
    ID_EMPRESA_DESHIDRATACION = 4,
}

export enum EnumDescripcionTcTipoSolicitudCamPlural {
    PARCELA = 'Parcelas',
    CONFECCION = 'Almacenes',
    INVERNADERO = 'Invernaderos',
    EMPRESA_DESHIDRATACION = 'Empresas Deshidratadoras',
    RECINTOS = 'Recintos',
}

export enum EnumDescripcionTcTipoSolicitudCamSingular {
    PARCELA = 'Parcela',
    CONFECCION = 'Almacén',
    INVERNADERO = 'Invernadero',
    EMPRESA_DESHIDRATACION = 'Empresa Deshidratadora',
    RECINTO = 'Recinto',
}

// @author: si se edita ésta lista, tened en cuenta que afecta al pipe IconoEstadoSolicitudCam
export enum EnumIdsTcEstadoSolicitudCam {
    ID_BORRADOR = 1,
    ID_PENDIENTE = 2,
    ID_VALIDADA = 3, // Por CA o EA
    ID_DEVUELTA = 4, // Por CA o EA
    ID_ACEPTADA = 5, // Por CA
    ID_RECHAZADA = 6, // Por CA
    ID_ANULADA = 7,
}

export enum EnumIdsTcEstadoPvCam {
    ID_NO_PRESENTADO = 1,
    ID_PRESENTADO = 2,
    ID_DEVUELTO = 3,
    ID_ACEPTADO = 4,
    ID_RECHAZADO = 5,
}

export enum DialogMode {
    Basic = 'Basic', // Permite mostrar la lista en modo básico.
    Embedded = 'Embedded', // Por ejemplo, el modo embebido se utiliza por ejemplo para mostrar los recintos-cultivos seleccionados en una solicitud de campaña o en una UI.
    Dialog = 'Dialog', // Por ejemplo, se utilizaría en la ventana que permite seleccionar recintos-cultivos para una solicitud de campaña o en una UI
}

export enum EnumIdsTwTcEstadoValidacionSolicitudCam {
    PENDIENTE = 1,
    VALIDADA = 2,
    DEVUELTA = 3,
}

export enum EnumIdsTwTcEstadoAceptacionSolicitudCam {
    PENDIENTE = 1,
    ACEPTADA = 2,
    RECHAZADA = 3,
    DEVUELTA_A_EA = 4,
}

// @author: si se edita ésta lista, tened en cuenta que afecta al pipe IconoEstadoUnidadInspeccion
export enum EnumIdsTcEstadoUnidadInspeccion {
    ID_SIN_ASIGNAR = 0,
    ID_PREINSCRITA = 1,
    ID_ELIMINADA = 2,
    ID_EN_TRAMITE = 3,
    ID_RECHAZADA_TEMP = 4,
    ID_RECHAZADA = 5,
    ID_AUTORIZADA_POR_EA = 6,
    ID_AUTORIZADA_EXPORT = 7,
    ID_SUSPENDIDA = 8,
    ID_BAJA = 9,
    ID_PTE_AFORAR = 10,
}

export enum EnumTcEstadoUnidadInspeccion {
    SIN_ASIGNAR = 'Sin Asignar',
    PREINSCRITA = 'Preinscrita',
    ELIMINADA = 'Eliminada',
    EN_TRAMITE = 'En trámite',
    RECHAZADA_TEMP = 'Rechazada temporalmente',
    RECHAZADA = 'Rechazada',
    AUTORIZADA_POR_EA = 'Autorizada por E.A.',
    AUTORIZADA_EXPORT = 'Autorizada para Exportar',
    SUSPENDIDA = 'Suspendida',
    BAJA = 'Baja',
    PTE_AFORAR = 'Pte. Aforar',
}

export enum DialogSelectionMode {
    None = 'none',
    Single = 'single',
    Multiple = 'multiple',
}
